__turbopack_context__.v({
  "aura": "website-trust-sections-module__1wNj_W__aura",
  "auraVideo": "website-trust-sections-module__1wNj_W__auraVideo",
  "australiaIcon": "website-trust-sections-module__1wNj_W__australiaIcon",
  "badge": "website-trust-sections-module__1wNj_W__badge",
  "controls": "website-trust-sections-module__1wNj_W__controls",
  "details": "website-trust-sections-module__1wNj_W__details",
  "detailsReserve": "website-trust-sections-module__1wNj_W__detailsReserve",
  "detailsSizer": "website-trust-sections-module__1wNj_W__detailsSizer",
  "eyebrow": "website-trust-sections-module__1wNj_W__eyebrow",
  "flag": "website-trust-sections-module__1wNj_W__flag",
  "footer": "website-trust-sections-module__1wNj_W__footer",
  "intro": "website-trust-sections-module__1wNj_W__intro",
  "orbit": "website-trust-sections-module__1wNj_W__orbit",
  "region": "website-trust-sections-module__1wNj_W__region",
  "regionVisual": "website-trust-sections-module__1wNj_W__regionVisual",
  "regions": "website-trust-sections-module__1wNj_W__regions",
  "security": "website-trust-sections-module__1wNj_W__security",
});
